import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { ThunkAction } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { configureStore } from '@reduxjs/toolkit';
import type { Action } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const middleware = (getDefaultMiddleware) => {
  const middlewares = getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action types
      ignoredActions: [],
    },
  });

  if (process.env.NODE_ENV === 'development') {
    middlewares.push(
      createLogger({})
    );
  }

  return middlewares;
};

const store = configureStore({
  reducer: rootReducer,
  // middleware,
  devTools: process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS === 'true' || process.env.NODE_ENV === 'development',
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, undefined, Action<string>>;

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const useDispatch = () => useReduxDispatch<AppDispatch>();

export default store;
